// MedicationAPI.js
import axios from 'axios';

const BASE_URL = "https://app.nocodb.com/api/v2/tables/mfuk6etm30kay6k/records";
const API_TOKEN = "BJbCKPah3Ph7D1BIgg_Uayk_HVCwef3JDiRUiBab";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'xc-token': API_TOKEN,
  },
});

api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response?.data || error.message);
    throw error;
  }
);


const getMedicationById = async (recIdValue) => {
  const response = await api.get('/', {
    params: { where: `(rec_Id,eq,${recIdValue})` },
  });

  return response.data?.list?.[0];
};


// ✅ Add medication
export const addMedication = async (medicationData) => {
  try {
    const transformedData = {
      name: medicationData.name || '',
      generic: medicationData.generic || '',
      qty: medicationData.qty ? parseInt(medicationData.qty) : 0,
      price_per_strip: medicationData.price_per_strip ? parseFloat(medicationData.price_per_strip) : 0,
      expiry_date: medicationData.expiry || '',
    };

    const response = await api.post('/', transformedData);
    console.log('Add medication response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error adding medication:', error);
    throw error;
  }
};

// ✅ Get all medications
export const getAllMedications = async ({ limit = 10, offset = 0, search = '' } = {}) => {
  try {
    const response = await api.get('/', {
      params: {
        limit,
        offset,
        shuffle: 0,
        where: search ? `(name,like,%${search}%)~or(generic,like,%${search}%)` : '',
      },
    });

    const transformedList = response.data.list.map(item => ({
      rec_Id: item.rec_Id,
      name: item.name || 'N/A',
      generic: item.generic || 'N/A',
      qty: item.qty ?? 0,
      price: item.price != null ? parseFloat(item.price) : 0,
      price_per_strip: item.price_per_strip != null ? parseFloat(item.price_per_strip) : 0,
      expiry_date: item.expiry_date || 'N/A',
    }));

    return {
      list: transformedList,
      pageInfo: {
        totalRows: response.data.pageInfo?.totalRows || transformedList.length,
        page: response.data.pageInfo?.page || Math.floor(offset / limit) + 1,
        pageSize: response.data.pageInfo?.pageSize || limit,
      },
    };
  } catch (error) {
    console.error('Error fetching medications:', error);
    throw error;
  }
};

// ✅ Update medication
export const updateMedication = async (recIdValue, medicationData) => {
  try {
    // Step 1: Look up the internal Id using rec_Id
    console.log("🔍 Looking up internal Id for rec_Id:", recIdValue);
    const searchRes = await api.get('/', {
      params: { where: `(rec_Id,eq,${recIdValue})` },
    });

    const match = searchRes.data?.list?.[0];
    console.log("👉 Full record for rec_Id lookup:", match);

    if (!match || !match.Id) {
      throw new Error(`No record found for rec_Id: ${recIdValue}`);
    }

    const internalId = match.Id;
    console.log(`✅ Will UPDATE using internal Id: ${internalId}`);

    // Step 2: Prepare the transformed data
    const transformedData = {
      Id: internalId, // Include the Id in the request body
      name: medicationData.name || '',
      generic: medicationData.generic || '',
      qty: medicationData.qty ? parseInt(medicationData.qty) : 0,
      price_per_strip: medicationData.price_per_strip ? parseFloat(medicationData.price_per_strip) : 0,
      expiry_date: medicationData.expiry || '',
    };

    // Step 3: Send the PATCH request with the data (including Id) in the body
    const response = await api.patch('/', transformedData);
    console.log('Update medication response:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error updating medication with rec_Id ${recIdValue}:`, error.response?.data || error.message);
    throw error;
  }
};

// ✅ Delete medication
export const deleteMedication = async (recIdValue) => {
  try {
    console.log("🔍 Looking up internal Id for rec_Id:", recIdValue);

    // Verify the record exists
    const searchRes = await api.get('/', {
      params: { where: `(rec_Id,eq,${recIdValue})` },
    });

    const match = searchRes.data?.list?.[0];
    console.log("👉 Full record for rec_Id lookup:", match);

    if (!match || !match.Id) throw new Error(`No record found for rec_Id: ${recIdValue}`);

    const internalId = match.Id;
    console.log(`✅ Will DELETE using internal Id: ${internalId}`);

    // Use bulk delete with Id in the request body
    const delRes = await api.delete('/', {
      data: { Id: internalId },
    });

    console.log("🗑️ Deleted:", delRes.data);
    return { success: true };
  } catch (error) {
    console.error(`❌ Error deleting rec_Id ${recIdValue}:`, error.response?.data || error.message);
    throw error;
  }
};

export const MedicationAPI = {
  create: addMedication,
  getAll: getAllMedications,
  update: updateMedication,
  delete: deleteMedication,
    getById: getMedicationById,
};

export default MedicationAPI;

// // // """"""""""""""""""""""""""""""""""""""""""WORKING DONE """""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""

